<template>
  <div class="risk-summary-card">
    <div class="risk-summary-header">
      <h3 class="section-title-compact">
        Overall Risk Rating
      </h3>
      <div class="risk-score-compact">
        <span class="risk-score-value-compact">{{ summary.totalScore }}</span>
        <span class="risk-score-label-compact">{{ summary.rating }}</span>
      </div>
    </div>
    <div class="risk-breakdown-compact">
      <div v-for="risk in summary.risks" :key="risk.name" class="risk-item-compact">
        <div class="risk-item-header">
          <span class="risk-name-compact">{{ risk.name }}</span>
          <span class="risk-scores-compact">
            <span class="score-obtained-compact">{{ risk.obtained }}</span>
            <span class="score-separator-compact">/</span>
            <span class="score-total-compact">{{ risk.total }}</span>
          </span>
        </div>
        <div class="risk-bar-compact">
          <div class="risk-bar-fill-compact" :style="{ width: formatPercentage(risk.percentage) }" :class="getRiskColorClass(risk.percentage)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RiskRatingSummary',
  props: {
    summary: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatPercentage(value) {
      if (value === null || value === undefined || value === '') return '0%'
      const num = typeof value === 'number' ? value : parseFloat(value)
      if (isNaN(num)) return String(value)
      return (num * 100).toFixed(0) + '%'
    },
    
    getRiskColorClass(percentage) {
      if (percentage >= 0.8) return 'risk-low'
      if (percentage >= 0.6) return 'risk-medium'
      return 'risk-high'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../index.scss';

.risk-summary-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.risk-summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
}

.section-title-compact {
  font-size: 0.95rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
  font-family: $brand-font-medium;
}

.risk-score-compact {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.risk-score-value-compact {
  font-size: 1.75rem;
  font-weight: 700;
  color: #2d3748;
  font-family: $brand-font-medium;
}

.risk-score-label-compact {
  font-size: 0.85rem;
  color: #6c757d;
  font-weight: 500;
  font-family: $brand-font-regular;
}

.risk-breakdown-compact {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
}

.risk-item-compact {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.risk-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}

.risk-name-compact {
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
  font-family: $brand-font-medium;
  flex: 1;
}

.risk-scores-compact {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.8rem;
}

.score-obtained-compact {
  font-weight: 600;
  color: #2d3748;
  font-family: $brand-font-medium;
}

.score-separator-compact {
  color: #adb5bd;
}

.score-total-compact {
  color: #6c757d;
  font-family: $brand-font-regular;
}

.risk-bar-compact {
  height: 6px;
  background: #f1f3f5;
  border-radius: 3px;
  overflow: hidden;
}

.risk-bar-fill-compact {
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 3px;
  
  &.risk-low {
    background: #10b981;
  }
  
  &.risk-medium {
    background: #f59e0b;
  }
  
  &.risk-high {
    background: #ef4444;
  }
}

@media (max-width: 768px) {
  .risk-breakdown-compact {
    grid-template-columns: 1fr;
  }
}
</style>

